import React, { Component } from 'react';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';
import DateTimeRangePicker from '@wojtekmaj/react-datetimerange-picker';

class DateRangePicker extends Component {
  render() {
    const { value, onChange } = this.props.input;
    return (
      <DateTimeRangePicker
        disableClock
        onChange={onChange}
        value={value}
        isCalendarOpen
        disabled={this.props.disabled}
        locale={this.props.currentLanguage || 'en'}
      />
    );
  }
}
export default connect(store => ({
  currentLanguage: store.locale.currentLanguage,
}))(localize()(DateRangePicker));
